module.exports = __webpack_public_path__ + "img/map-pin.55ce27ce.svg";